import {Panel} from 'components/Panel'
import {FormType} from 'mixins/FormTypes'
import React, {createRef} from 'react'
import Form from '../../mixins/form'
import {FontAwesomeIcon as Icon} from '@fortawesome/react-fontawesome'
import AlertDanger from '../../components/Alerts/AlertDanger'
import {faArrowLeft, faRedo} from '@fortawesome/free-solid-svg-icons'
import {connect} from 'react-redux'
import {GlobalState} from '../../state'
import {match} from 'react-router'
import {Http} from '../../mixins/http'
import {NavLink} from 'react-router-dom'
import Trans from '../../components/Trans'

type ResetPasswordProps = {
  token: string | null | undefined
  username: string | null | undefined
}

type ResetPasswordState = {
  form: FormType
  passwordResetResponseSuccess: boolean | null
}

type PasswordResetResponse = {
  errors?: Array<Array<string>>
  success?: boolean
}

class ResetPassword extends React.Component<ResetPasswordProps, ResetPasswordState> {
  private form: FormType = new Form({})
  private usernameRef = createRef<HTMLInputElement>()
  private passwordRef = createRef<HTMLInputElement>()
  private passwordConfirmationRef = createRef<HTMLInputElement>()

  constructor(props: ResetPasswordProps) {
    super(props)
    this.state = {
      form: this.form,
      passwordResetResponseSuccess: null
    }

    if (this.usernameRef.current) {
      this.usernameRef.current.value = this.props.username || ''
    }
  };

  resetPassword = async (event: React.MouseEvent) => {
    event.preventDefault()
    event.stopPropagation()
    const username = this.usernameRef.current ? this.usernameRef.current.value.split('.')[1] : null
    const domain = this.usernameRef.current ? this.usernameRef.current.value.split('.')[0] : null
    const form = new Form({
      username: username,
      domain: domain,
      token: this.props.token,
      password: this.passwordRef.current ? this.passwordRef.current.value : null,
      password_confirmation: this.passwordConfirmationRef.current ? this.passwordConfirmationRef.current.value : null
    })
    await this.setState({
      form: form,
      passwordResetResponseSuccess: null
    })

    const response = await Http.post<PasswordResetResponse>('/password/reset', {state: this, form: this.state.form})

    if (!response || response.errors) {
      return this.setState({
        passwordResetResponseSuccess: false
      })
    }

    location.replace('/')
  }

  render() {
    return (
      <div className='border-t-4 border-blue-800 overflow-y-scroll scrolling-smooth md:scrollbar  w-full h-full'>
        <div className='flex flex-col p-2 w-full max-w-2xl lg:max-w-3xl mx-auto'>
          <Panel>
            <div className='flex flex-col sm:flex-row flex-wrap w-full px-6 py-3'>
              <div className='text-gray-600 font-semibold tracking-wide whitespace-no-wrap w-full lg:w-1/3 text-center sm:text-left'>
                <Icon icon={faRedo} />
                <span> <Trans>Passwort zurücksetzten</Trans></span>
              </div>
              <form className='w-full lg:w-2/3 flex flex-col'>
                {
                  this.state.form.errors.has('token') ?
                    <AlertDanger><Trans>Der Link dem Sie folgten war entweder falsch, oder ist abgelaufen.</Trans></AlertDanger>
                    : null
                }

                {
                  this.state.passwordResetResponseSuccess === false ?
                    <AlertDanger><Trans>Beim speichern Ihres neuen Passwort ist ein Fehler aufgetreten.</Trans></AlertDanger>
                    : null
                }

                <div>
                  <label className='block tracking-wide text-gray-600 font-semibold mb-1'><Trans>Benutzername</Trans></label>
                  <input defaultValue={this.props.username || ''} name='username' ref={this.usernameRef} type='text' placeholder='Benutzername' className='shadow appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300' />

                  {
                    this.state.form.errors.has('username') || this.state.form.errors.has('domain') ?
                      <AlertDanger><Trans>Benutzername muss ausgefüllt sein. (Beispiel: firma.benutzername)</Trans></AlertDanger>
                      : null
                  }
                </div>

                <div className='mt-4'>
                  <label className='block tracking-wide text-gray-600 font-semibold mb-1'><Trans>Passwort</Trans></label>
                  <input name='password' ref={this.passwordRef} type='password' placeholder='***************' className='shadow appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300' />

                  {
                    this.state.form.errors.has('password') ?
                      <AlertDanger><Trans>Das Passwort muss mindestens 6 Zeichen lang sein.</Trans></AlertDanger>
                      : null
                  }
                </div>

                <div className='mt-4'>
                  <label className='block tracking-wide text-gray-600 font-semibold mb-1'><Trans>Passwort wiederholen</Trans></label>
                  <input name='passwordConfirmation' ref={this.passwordConfirmationRef} type='password' placeholder='***************' className='shadow appearance-none block w-full bg-gray-200 text-gray-800 border border-gray-200 rounded py-2 px-3 leading-tight hover:bg-gray-100 focus:bg-gray-100 focus:border-gray-300' />

                  {
                    this.state.form.errors.has('password') && ['The password confirmation does not match.'].indexOf(this.state.form.errors.get('password') || '') !== -1 ?
                      <AlertDanger><Trans>Die Passwörter stimmen nicht überein.</Trans></AlertDanger>
                      : null
                  }
                </div>

                <div className='mt-4 flex flex-row justify-between'>
                  <div className='mt-4 flex justify-start'>
                    <NavLink to='/login' className='text-gray-600 hover:text-blue-700 hover:font-semibold flex items-center mr-2 text-xs'>
                      <Icon icon={faArrowLeft} className={'mr-1'} />
                      <Trans>Zurück</Trans>
                    </NavLink>
                  </div>

                  <div className='mt-4 flex justify-end'>
                    <button className='rounded bg-gray-300 hover:bg-gray-400 text-gray-800 px-4 py-2 font-semibold shadow' onClick={this.resetPassword}>
                      {this.state.form.busy ?
                        <Icon icon='spinner' spin={true} />
                        :
                        <Icon icon={faRedo} />
                      }
                      <span> <Trans>Passwort zurücksetzten</Trans></span>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </Panel>
        </div>
      </div>
    )
  }
}

type CustomProps = {
  match?: match<{
    token: string | undefined
    username: string | undefined
  }>
} | undefined

export default connect((state: GlobalState, props: CustomProps) => ({
  token: props && props.match ? props.match.params.token : null,
  username: props && props.match ? props.match.params.username : null
}))(ResetPassword)
